
export class ItemSaleMonthlyLookupDto {
    public q: number; // quantity
    public v: number; // value
    public pq: number; // purchaseQuantity
    public pv: number; // purchaseValue
    
}
